// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + chunkId + "." + "e6a12c7adb25db6f2a81" + ".min.js";
};